module.exports = __webpack_public_path__ + "img/utility-impostor-figure.c9020d2a.png";